import { render, staticRenderFns } from "./ProgramOverview.vue?vue&type=template&id=0dbfbb11&scoped=true"
import script from "./ProgramOverview.vue?vue&type=script&lang=js"
export * from "./ProgramOverview.vue?vue&type=script&lang=js"
import style0 from "./ProgramOverview.vue?vue&type=style&index=0&id=0dbfbb11&prod&lang=less"
import style1 from "./ProgramOverview.vue?vue&type=style&index=1&id=0dbfbb11&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbfbb11",
  null
  
)

export default component.exports